// src/pages/freevaluation/FreeValuationProcessing.jsx
//
// Polls the backend status endpoint until the Celery task marks
// ``free_valuation_delivered_at``, then redirects to the "klart"
// confirmation page. Timeout after ~90s → show a "check your email"
// fallback so the user doesn't stare at a spinner if SMTP is slow.
//
// Route: /gratis-vardering/behandlas/:workspaceId

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { request } from "../../services/server";
import "./freevaluation.css";

const _POLL_INTERVAL_MS = 2500;
const _POLL_TIMEOUT_MS = 90_000;

export default function FreeValuationProcessing() {
  const { workspaceId } = useParams();
  const navigate = useNavigate();
  const [phase, setPhase] = useState("waiting");

  useEffect(() => {
    let cancelled = false;
    const startedAt = Date.now();

    async function poll() {
      if (cancelled) return;
      try {
        const data = await request(
          `/valuation/free-valuation/status/${workspaceId}/`,
        );
        if (cancelled) return;
        if (data?.delivered) {
          navigate(`/gratis-vardering/klart/${workspaceId}`, { replace: true });
          return;
        }
      } catch {
        // Transient failures are OK — keep polling. If auth expired
        // mid-flow the redirect target below handles it.
      }
      if (Date.now() - startedAt > _POLL_TIMEOUT_MS) {
        setPhase("timeout");
        return;
      }
      setTimeout(poll, _POLL_INTERVAL_MS);
    }
    poll();

    return () => {
      cancelled = true;
    };
  }, [workspaceId, navigate]);

  return (
    <div className="fv-page">
      <div className="fv-card">
        {phase === "waiting" && (
          <>
            <div className="fv-spinner" aria-hidden="true" />
            <h1>Beräknar din värdering…</h1>
            <p>
              Vi tolkar SIE-filen och räknar fram ett värdeintervall.
              Det brukar ta 5–30 sekunder.
            </p>
          </>
        )}
        {phase === "timeout" && (
          <>
            <h1>Det tog längre tid än väntat</h1>
            <p>
              Vi jobbar fortfarande på din värdering. Så snart den
              är klar mailar vi den till dig — du behöver inte
              vänta på den här sidan.
            </p>
            <p className="fv-muted">
              Om det inte kommer något mail inom en timme, kontakta
              oss så tittar vi på det.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
